import brand from "../../assets/img/brand-nav.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions/cartActions";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function LeftCheckOut({ totalPrice, cart }) {
  const navigate = useNavigate();
  const [showShipForm, setShowShipForm] = useState(true);
  const store = useSelector((state) => state);
  const dispatch = useDispatch();

  const MySwal = withReactContent(Swal);
  let timerInterval;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    e.preventDefault();

    MySwal.fire({
      title: <span className="f-roboto text-dark">Please wait</span>,
      html: (
        <span className="f-roboto text-dark">Procesing your payment...</span>
      ),
      timer: 4000,
      timerProgressBar: true,
      didOpen: () => {
        MySwal.showLoading();
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    });

    if (!data.apartment) {
      data.apartment = "";
    }
    if (!data.company) {
      data.company = "";
    }

    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_API_URL + `/api/orders`,
        headers: { Authorization: ` Bearer ${store.customer.access_token}` },
        data: {
          products: cart,
          totalAmount: (totalPrice * 1.1).toFixed(2),
          shippingAddress:
            data.address + " " + data.apartment + " " + data.city,
          customerName: data.firstname + " " + data.lastname,
          phonenumber: data.phoneNumber,
          companyName: data.company,
          customerId: store.customer.id,
        },
      });

      setTimeout(() => {
        navigate(`/customers/${store.customer.firstname.toLowerCase()}/orders`);
        dispatch(actions.resetCart);

        MySwal.fire({
          icon: "success",
          title: (
            <span className="f-roboto text-dark">Thanks for choosing us</span>
          ),
          html: (
            <span className="f-roboto text-dark">
              You will receive your order in the next few days
            </span>
          ),
        });
      }, 3300);
    } catch (error) {
      console.log(error);
    }
  };

  const notify = () => {
    toast.info("This functionality exceeded the scope of this project.", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const handlePickupSubmit = (e) => {
    e.preventDefault();
    notify();
  };

  return (
    <div className="px-1 pt-2 px-sm-5 pt-sm-5">
      <div className="d-flex justify-content-center mb-3">
        <Link to="/">
          <img
            src={brand}
            alt="Premium Teas"
            className="logo-checkout img-fluid"
          />
        </Link>
      </div>
      <form>
        <h2 className="fs-5 f-roboto fw-light mb-4">Delivery method</h2>
        <div className="form-check border p-2 rounded mb-2">
          <input
            className="form-check-input ms-1"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            onClick={() => setShowShipForm(true)}
          />
          <label
            className="form-check-label f-roboto check-box"
            htmlFor="flexRadioDefault1"
          >
            <i className="bi bi-truck ms-2 checkout-icons"></i> Ship
          </label>
        </div>
        <div className="form-check border p-2 rounded">
          <input
            className="form-check-input ms-1"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            onClick={() => setShowShipForm(false)}
          />
          <label
            className="form-check-label f-roboto check-box"
            htmlFor="flexRadioDefault2"
          >
            <i className="bi bi-shop ms-2 checkout-icons"></i> Pick up
          </label>
        </div>
      </form>
      <form
        className={`mt-5 ${showShipForm ? "d-block" : "d-none"}`}
        onSubmit={handleSubmit(onSubmit)}
      >
        <h2 className="fs-5 f-roboto fw-light mb-4">Shipping address</h2>
        <div className="row justify-content-between">
          <div className="col-lg-6">
            <label className="visually-hidden" htmlFor="firstname">
              First Name
            </label>
            <input
              className="form-control mt-3 p-2 bg-white"
              id="firstname"
              type="text"
              placeholder="First name"
              defaultValue={store.customer.firstname}
              readOnly
              {...register("firstname", { required: true })}
            />
            {errors.firstname && (
              <span className="f-roboto fs-7 text-danger">
                This field is required
              </span>
            )}
          </div>
          <div className="col-lg-6">
            <label className="pt-4 visually-hidden" htmlFor="lastname">
              Lastname
            </label>
            <input
              className="form-control mt-3 p-2 bg-white"
              id="lastname"
              type="text"
              placeholder="Last name"
              defaultValue={store.customer.lastname}
              readOnly
              {...register("lastname", { required: true })}
            />
            {errors.lastname && (
              <span className="f-roboto fs-7 text-danger">
                This field is required
              </span>
            )}
          </div>
        </div>
        <label htmlFor="company" className="visually-hidden">
          Company
        </label>
        <input
          className="form-control mt-3 p-2"
          id="company"
          type="text"
          placeholder="Company (optional)"
          {...register("company")}
        />
        <label htmlFor="address" className="visually-hidden">
          Address
        </label>
        <input
          className="form-control mt-3 p-2"
          id="address"
          type="text"
          placeholder="Address"
          {...register("address", { required: true })}
        />
        {errors.address && (
          <span className="f-roboto fs-7 text-danger">
            This field is required
          </span>
        )}

        <label htmlFor="apartment" className="visually-hidden">
          Apartment, suite, etc. (optional)
        </label>
        <input
          className="form-control mt-3 p-2"
          id="apartment"
          type="text"
          placeholder="Apartment, suite, etc. (optional)"
          {...register("apartament")}
        />
        <label htmlFor="city" className="visually-hidden">
          City
        </label>
        <input
          className="form-control mt-3 p-2"
          id="city"
          type="text"
          placeholder="City"
          {...register("city", { required: true })}
        />
        {errors.city && (
          <span className="f-roboto fs-7 text-danger">
            This field is required
          </span>
        )}

        <label htmlFor="phoneNumber" className="visually-hidden">
          Phone
        </label>
        <input
          className="form-control mt-3 p-2"
          id="phoneNumber"
          type="text"
          placeholder="Phone"
          {...register("phoneNumber", { required: true })}
        />
        {errors.phoneNumber && (
          <span className="f-roboto fs-7 text-danger">
            This field is required
          </span>
        )}

        <div className="form-check mt-2">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label
            className="form-check-label f-roboto fs-7 ms-1"
            htmlFor="flexCheckDefault"
          >
            Save this information for next time
          </label>
        </div>
        <div className="d-flex align-items-center mt-3 mb-5">
          <button
            type="submit"
            className="btn btn-yellow p-4 d-flex align-items-center f-roboto"
          >
            Place Order
          </button>
          <Link
            to="/cart"
            className="ms-4 link-yellow f-roboto text-decoration-none"
          >
            Return to cart{" "}
          </Link>
        </div>
      </form>
      <form
        onSubmit={(e) => handlePickupSubmit(e)}
        className={`pickup-form mt-5 ${showShipForm ? "d-none" : "d-block"}`}
      >
        <h2 className="fs-5 f-roboto fw-light mb-4">Pickup locations</h2>
        <div className="form-check d-flex align-items-center border p-2 rounded">
          <input
            className="form-check-input ms-1"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault3"
            defaultChecked
          />
          <label
            className="form-check-label f-roboto check-box py-2"
            htmlFor="flexRadioDefault3"
          >
            <div className="h-100 ms-2">
              <p className="mb-0">Tienda Natural</p>
              <p className="mb-0 fs-8">
                San José 1821, esq. Minas. Montevideo, UY
              </p>
            </div>
          </label>
        </div>
        <div className="form-check d-flex align-items-center border p-2 my-3 rounded">
          <input
            className="form-check-input ms-1"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault3"
          />
          <label
            className="form-check-label f-roboto check-box py-2"
            htmlFor="flexRadioDefault3"
          >
            <div className="h-100 ms-2">
              <p className="mb-0">La Despensa</p>
              <p className="mb-0 fs-8">
                Garibaldi 1458, esq. Juan Paulier. Montevideo, UY
              </p>
            </div>
          </label>
        </div>
        <div className="form-check d-flex align-items-center border p-2 rounded">
          <input
            className="form-check-input ms-1"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault3"
          />
          <label
            className="form-check-label f-roboto check-box py-2"
            htmlFor="flexRadioDefault3"
          >
            <div className="h-100 ms-2">
              <p className="mb-0">La Huerta de Ramona</p>
              <p className="mb-0 fs-8">
                Walter 956, esq. Avda. Pandiani. San José, UY
              </p>
            </div>
          </label>
        </div>
        <div className="d-flex align-items-center mt-3 mb-5">
          <button className="btn btn-yellow p-4 d-flex align-items-center f-roboto">
            Place order
          </button>
          <Link
            to="/cart"
            className="ms-4 link-yellow f-roboto text-decoration-none"
          >
            Return to cart{" "}
          </Link>
        </div>
      </form>
      <hr className="mt-5" />
      <div className="mb-5 text-center text-md-start">
        <Link
          to="/cart"
          className="ms-sm-1 link-yellow f-roboto text-decoration-none fs-7"
        >
          {" "}
          Refund policy
        </Link>
        <Link
          to="/cart"
          className="ms-4 link-yellow f-roboto text-decoration-none fs-7"
        >
          {" "}
          Shipping policy
        </Link>
        <Link
          to="/cart"
          className="ms-4 link-yellow f-roboto text-decoration-none fs-7"
        >
          {" "}
          Privacy policy
        </Link>
        <Link
          to="/cart"
          className="ms-4 link-yellow f-roboto text-decoration-none fs-7"
        >
          {" "}
          Terms of service
        </Link>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default LeftCheckOut;
